import { useEffect, useRef, useState } from 'react';
import i18n from '../../../../../utils/translations/i18n';
import { currencyFormatter } from '../../../../../utils/currency';
import { TextBoxWithLabelAbove } from '../../../elements/textbox';
import Tooltip from '../../../elements/tooltip';
import { config } from '../../../../../utils/config';
import { QuantityPrice as priceCalculator } from 'pricing-helper';
import { ReactComponent as Warning } from '../../../../../assets/icons/warning.svg';
import { ReactComponent as RoundLoader } from '../../../../../assets/icons/loader.svg';
import useWindowSize from '../../../../../utils/customHooks/useWindowSize';
import { addCommasToNumber } from '../../../../../utils/textFormatters';
/*helper */
import {
  provideSliderValues,
  getSliderValForQty,
  getActualQty,
} from './sliderHelper';
import { useDispatch } from 'react-redux';
import { setLastQtyEditMethod } from '../../../../../store/application';
import { GaConstants } from '../../../../../enums/gaConstants';

const sliderMap={};
const qtyInputMap={};
export interface SliderValueType {
  min: number;
  max: number;
  value: number;
  sliderStepToOriginalIncrementMap: any;
  stepsToQuantityObj: any;
  quantityToStepsObj: any;
}

const endingSymbolAfterSavingStatement = {
  "es-ES":".",
  "da-DK":"",
}
const PriceTier = ({
  tierPricesData,
  selectedQty,
  setSelectedQty,
  setIsDisabled,
  setupCharge,
  setupChargeWithGlobalDiscount,
  setupChargeAdded,
  fractionDigits,
  taxRate,
  mainItem,
  setSliderUnitPrice = (price: number) => {},
  setSliderFreeQty = (qty: number) => {}
}) => {
  const { t } = i18n;
  const [width] = useWindowSize();
  const sliderRef: any = useRef(null);
  const holdKeyDownActionRef:any = useRef(false);
  const sliderParentRef: any = useRef(null);
  const sliderMobileRef: any = useRef(null);
  const bubbleRef: any = useRef(null);
  const bubbleMobileRef: any = useRef(null);
  const totalTiers = tierPricesData?.tierObject?.length ?? 0;
  const step: any = 1;
  const [timerId, setTimerId] = useState<NodeJS.Timeout | null>(null);
  const [unitPrice, setUnitPrice] = useState(
    tierPricesData?.tierObject[0]?.unitPrice
  );
  const [strikeOutUnitPrice, setStrikeOutUnitPrice] = useState(null);
  const [savings, setSavings]: any = useState(0);
  const [freeQty, setFreeQty] = useState(null);
  const [showLessQtyWarning, setShowLessQtyWarning] = useState(false);
  const [showGreaterQtyWarning, setShowGreaterQtyWarning] = useState(false);
  const [totalPrice, setTotalPrice] = useState(
    tierPricesData?.tierObject?.[0]?.subtotalValue
  );
  const [circularLoader, setCircularLoader] = useState(false);
  const [textBoxQty, setTextBoxQty]: any = useState(Number(selectedQty));
  const [tierSetupCharge, setTierSetupCharge] = useState(setupCharge);
  const [discountedTierSetupCharge, setDiscountedTierSetupCharge] = useState(setupChargeWithGlobalDiscount);

  const [sliderValues, setSliderValues] = useState<SliderValueType>({
    min: 0,
    max: 0,
    value: 0,
    sliderStepToOriginalIncrementMap: {},
    stepsToQuantityObj: {},
    quantityToStepsObj: {},
  });
  const minTierQty: number = Number(tierPricesData?.tierObject[0]?.quantity);
  const maxTierQty: number = Number(tierPricesData?.tierObject[totalTiers - 1]?.quantity);
  const dispatch = useDispatch();

  const setBubble = (actualQty) => {
    const qty: number = getSliderValForQty(
      actualQty,
      sliderValues?.['quantityToStepsObj']
    );
    const min: number = Number(sliderValues?.min ? sliderValues?.min : 0);
    const max: number = Number(sliderValues?.max ? sliderValues?.max : 100);
    const sliderParent = sliderParentRef?.current?.getBoundingClientRect();
    const sliderParentWidth: number = sliderParent?.width;
    let sliderRect = sliderRef?.current?.getBoundingClientRect();
    let sliderMobileRect = sliderMobileRef?.current?.getBoundingClientRect();

    let sliderWidth: number = sliderRect?.width;
    let sliderMobileWidth: number = sliderMobileRect?.width;

    let bubbleMobileRect = bubbleMobileRef?.current?.getBoundingClientRect();
    let bubbleMobileWidth: number = bubbleMobileRect?.width;

    const noOfSteps: number = (max - min) / step;
    const currentSteps: number = (qty - min) / step;
    const oldStepSize: number = sliderWidth / noOfSteps;
    const diff: number =
      sliderRect?.left -
      sliderParent?.left +
      21 -
      (17 / noOfSteps) * currentSteps;
    const newVal: number =
      (diff + currentSteps * oldStepSize) / sliderParentWidth;
    bubbleRef.current.style.left = `${newVal * 100}%`;

    const newStepSizeForMobile: number =
      (sliderMobileWidth - bubbleMobileWidth) / noOfSteps;

    const newValForMobile: number = Number(newStepSizeForMobile * currentSteps);
    bubbleMobileRef.current.style.left = `${newValForMobile}px`;
  };

  useEffect(() => {
    setSliderUnitPrice(unitPrice ?? 0);
    setSliderFreeQty(freeQty ?? 0);
  }, [freeQty, unitPrice]);

  useEffect(() => {
    if (sliderValues&&!circularLoader) {
      setBubble(textBoxQty);
    }
  }, [textBoxQty, circularLoader,sliderValues, width]);

  useEffect(()=>{
    if(window) {
      const windowAppConfig = window["appConfig"];
      if(windowAppConfig) {
      windowAppConfig["setSliderBubbleForCart"] = function(){
      const inputElement = document.getElementById('edit-slider-box');
      const enterKeyEvent = new KeyboardEvent('keydown', {
      key: 'Enter',
      code: 'Enter',
      keyCode: 13,
      which: 13,
      bubbles: true,
      cancelable: true,
      });
      holdKeyDownActionRef.current = true
      inputElement?.dispatchEvent(enterKeyEvent);
      setTimeout(()=>{
        holdKeyDownActionRef.current=false
      }, 2000)
    }
    };
  }
  },[window])

  useEffect(() => {
    if (minTierQty && maxTierQty) {
      setPricingValue(selectedQty, null, false);
      const temp: SliderValueType = provideSliderValues(
        minTierQty,
        maxTierQty,
        Number(selectedQty)
      );
      setSliderValues(temp);
    }
  }, [minTierQty, maxTierQty]);

  const setPricingValue = (newQtyValue, type, isMouseUp) => {
    //type & isMouseUp for GA events

    const newTierPricesData: any = JSON.parse(JSON.stringify(tierPricesData));

    function updateSetupCharge(tier) {
      tier.setUpCharge = (tier.setupCharge / Math.pow(10, fractionDigits)).toFixed(fractionDigits);
      delete tier.setupCharge;
    }
    newTierPricesData.tierObject.forEach(updateSetupCharge);
    newTierPricesData.oldPrices.forEach(updateSetupCharge);

    const pricingCalcResp: any = priceCalculator?.calc(
      newTierPricesData,
      Number(newQtyValue),
      taxRate
    );

    if(pricingCalcResp?.tier?.setupCharge) setTierSetupCharge(pricingCalcResp?.tier?.setupCharge);
    if(pricingCalcResp?.discountedTier?.setupCharge !== tierSetupCharge && pricingCalcResp?.discountedTier?.setupCharge === 0) setDiscountedTierSetupCharge('Free');
    else setDiscountedTierSetupCharge(pricingCalcResp?.discountedTier?.setupCharge);

    const { freeQuantity, unitPrice, withTax } =
      pricingCalcResp?.discountedTier ?? {
        freeQuantity: 0,
        unitPrice: 0,
        withTax: { charges: { totalWithSetup: 0 }, default: { savings: 0 } },
      };
    if (freeQuantity > 0) setFreeQty(freeQuantity);
    if (pricingCalcResp?.tier?.unitPrice !== unitPrice)
      setStrikeOutUnitPrice(
        currencyFormatter(pricingCalcResp?.tier?.unitPrice, fractionDigits) ?? 0
      );
    else setStrikeOutUnitPrice(null);
    if(type==="box" && !(newQtyValue in qtyInputMap)) {
      qtyInputMap[newQtyValue]=1;
    }
    if(type==="slider" && isMouseUp && !(newQtyValue in sliderMap)) {
      sliderMap[newQtyValue]=1;
    }
    setUnitPrice(currencyFormatter(unitPrice, fractionDigits) ?? 0);
    setTotalPrice(withTax?.charges?.totalWithSetup ?? 0);
    setSavings(withTax?.default?.savings ?? 0);
  };

  const resetWarningAndDisabledStates = () => {
    setIsDisabled(false);
    setShowGreaterQtyWarning(false);
    setShowLessQtyWarning(false);
  };
  
  const updateSelectedQuantityPricingTextBoxQty = (newQtyValue, type, isMouseUp) => {

    setTextBoxQty(newQtyValue);
    setSelectedQty(newQtyValue);
    //type & isMouseUp for GA events
    setPricingValue(newQtyValue, type, isMouseUp);
  };

  const handleSliderChange = (event, isMouseUp) => {
    resetWarningAndDisabledStates();
    setSliderValues((pre: any) => {
        return { ...pre, value: parseInt(event?.target?.value) };
    });
    const userQty = getActualQty(
        parseInt(event?.target?.value),
        minTierQty,
        sliderValues?.sliderStepToOriginalIncrementMap,
        sliderValues?.['stepsToQuantityObj']
    );
    updateSelectedQuantityPricingTextBoxQty(userQty, "slider", isMouseUp);

    // Dispatch action for qty-selector
    dispatch(setLastQtyEditMethod(GaConstants.SLIDER));
  };

  const changeInputHandler = (value) => {
    resetWarningAndDisabledStates();
    let userQty: number = Number(value);
    setTextBoxQty(userQty);
    if (userQty < minTierQty) {
      setShowLessQtyWarning(true);
      userQty = minTierQty;
    } else if (userQty > maxTierQty) {
      setShowGreaterQtyWarning(true);
      userQty = maxTierQty;
    }
    setSliderValues((pre: any) => {
      return {
        ...pre,
        value: parseInt(
          getSliderValForQty(userQty, sliderValues?.['quantityToStepsObj'])
        ),
      };
    });
    if(holdKeyDownActionRef.current)return;
    updateSelectedQuantityPricingTextBoxQty(userQty, "box", false);
  };


  const handleInputChange = (event: any) => {
    const value = event?.target?.value;
    if (timerId) {
        clearTimeout(timerId);
    }
    setTextBoxQty(value);
    setCircularLoader(true);
    setIsDisabled(true);
    setTimerId(
        setTimeout(() => {
            changeInputHandler(value);
            setCircularLoader(false);
        }, 1500)
    );

    // Dispatch action for edit-slider-box
    dispatch(setLastQtyEditMethod(GaConstants.BOX));
  };

  const handleKeyDown = (event: any) => {
    if (event?.key === 'Enter') {
      if (timerId) {
        setCircularLoader(false);
        clearTimeout(timerId);
      }
      changeInputHandler(event?.target?.value);
    }
  };

  const pricingTierPart = (
    <>
      <div className='slider-container'>
        <p className='edit-quantity-title'>
          {t('product_details.edit_quantity')}
        </p>
        <div className='slider'>
          <div className='rangeQtyContainer desktop' ref={sliderParentRef}>
            <p>{addCommasToNumber(minTierQty)}</p>
            {textBoxQty?<output ref={bubbleRef} id='rangeBubble'>
              {addCommasToNumber(textBoxQty)}
            </output>:null}
            <input
              type='range'
              id='qty-selector'
              name='selector'
              ref={sliderRef}
              min={sliderValues?.min}
              max={sliderValues?.max}
              step={step}
              value={sliderValues?.value}
              autoComplete='off'
              onChange={(e)=>handleSliderChange(e,false)}
              onMouseUp={(e)=>handleSliderChange(e,true)}
            />
            <p>{addCommasToNumber(maxTierQty)}</p>
          </div>
          <div className='rangeQtyContainer mobile'>
            {textBoxQty?<output ref={bubbleMobileRef} id='rangeBubble'>
              {addCommasToNumber(textBoxQty)}
            </output>:null}
            <input
              type='range'
              id='qty-selector'
              name='selector'
              ref={sliderMobileRef}
              min={sliderValues?.min}
              max={sliderValues?.max}
              step={step}
              value={sliderValues?.value}
              autoComplete='off'
              onChange={(e)=>handleSliderChange(e,false)}
              onTouchEnd={(e)=>handleSliderChange(e,true)}
            />
            <div className='quantity-mobile'>
              <p>{addCommasToNumber(minTierQty)}</p>
              <p>{addCommasToNumber(maxTierQty)}</p>
            </div>
          </div>
        </div>
        <div className='qty-selected-container'>
          <TextBoxWithLabelAbove
            id='edit-slider-box'
            className=''
            name='qty-selected'
            placeholder=' '
            type='number'
            role='qty-selected'
            value={textBoxQty}
            label={t('product_details.quantity')}
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
            autocomplete='off'
            min={minTierQty}
            max={maxTierQty}
            step={step}
          />
          <div className='quantityBox'>
            <label>{t('product_details.price')}</label>
            <div>
              {tierPricesData?.isStrikeOutPricing && strikeOutUnitPrice && (
                <span id='strikeOutPriceUnitPrice'>{strikeOutUnitPrice}</span>
              )}
              {`${unitPrice}/${t('shopping_cart_details.unit')}  ${
                freeQty ? `+ ${freeQty} ${t('product_details.free')}` : ''
              }`}
            </div>
          </div>
        </div>
      </div>
    </>
  );

  return (
    <>
      {pricingTierPart}
      {setupChargeAdded && (
        <div className='slider-summary-total setup-charge'>
          <span>
            {t('shopping_cart_details.setup')}
            <Tooltip
              content={
                config('setupChargeTooltip') ??
                t('shopping_cart_details.setup_title')
              }
              direction='top'
            ></Tooltip>
          </span>
          {discountedTierSetupCharge !== tierSetupCharge && (
            <span>
              {discountedTierSetupCharge === 'Free' && (
                <span>{t('order_details.free')} </span>
              )}
              <span className='strike-out'>
                {currencyFormatter(tierSetupCharge, fractionDigits)}
              </span>
              &nbsp;
              {discountedTierSetupCharge !== 'Free' && (
                <span>
                  {currencyFormatter(
                    discountedTierSetupCharge,
                    fractionDigits
                  )}
                </span>
              )}
            </span>
          )}
          {discountedTierSetupCharge === tierSetupCharge && (
            <span>
              {currencyFormatter(discountedTierSetupCharge, fractionDigits)}
            </span>
          )}
        </div>
      )}
      <div className='slider-summary-total'>
        <span>{t('product_details.total_price')} </span>
        {circularLoader ? (
          <RoundLoader className='summary-loader' />
        ) : (
          <span className='bold'>
            {currencyFormatter(totalPrice, fractionDigits)}
          </span>
        )}
      </div>
      {savings > 0 && (
        <div className='you-save-container'>
          <div style={{ textAlign: 'center' }}>
            {t('shopping_cart_details.editModalSaving')}{' '}
            <span style={{ fontWeight: '500' }}>
              {currencyFormatter(savings, fractionDigits)}
            </span>
            {endingSymbolAfterSavingStatement[config('locale')] ?? '!'}
          </div>
          <div className='saving'></div>
        </div>
      )}
      {showGreaterQtyWarning && (
        <div className='warning-container'>
          <Warning className='icon-warning' />
          <span className='warning'>
            {t('shopping_cart_details.editModalMax_QtyWarning')}
          </span>
        </div>
      )}
      {showLessQtyWarning && (
        <div className='warning-container'>
          <Warning className='icon-warning' />
          <span className='warning'>
            {t('shopping_cart_details.editModalMin_QtyWarning')}
          </span>
        </div>
      )}
    </>
  );
};

export default PriceTier;